export enum FileFormat {
  'JSON' = 'json',
  'YAML' = 'yaml',
  'XML' = 'xml',
  'TOML' = 'toml',
  'CSV' = 'csv',
}
